import React from 'react'
import { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import WT from '@sscale/wtsdk';
import moment from 'moment'
import './Session.css'

import { vrtApiRequest } from '../../httpClient';
import {initializeSyncSdk, sendGroup} from '../../services/syncService'

import { resetStore as resetParticipantStore, setGainedToken} from '../../store/reducers/ParticipantReducer';
import {
  setSessionError, setJoinModalState, setSurveyModalState,
  setRoomProcessingModalState, setRoomCheckerError, setTimeBeforeMeeting,
  setJoinModalType, setParticipants, setCopyModal, addParticipant,
} from '../../store/reducers/SessionReducer';

import Video from '../Video/Video';
import JoinModal from '../JoinModal/JoinModal'
import RoomCheckerModal from '../RoomCheckerModal/RoomCheckerModal'
import CelebrityTable from './components/CelebrityTable/CelebrityTable'
import FooterButtons from './components/FooterButtons/FooterButtons'
import Player from '../Player/Player'
import SurveyModal from '../SurveyModal/SurveyModal';
import SessionError from './components/SessionError/SessionError';
import ParticipantsList from './components/ParticipantsList/ParticipantsList'
import ChatTabs from "../ChatTabs/ChatTabs";
import {deleteRoom} from "../../services/chats";
import CopyModal from "../JoinModal/components/CopyModal/CopyModal";
import useIsMobilePlatform from "../../hooks/useIsMobilePlatform";

function Session() {
  const { roomId = '' } = useParams();

  const dispatch = useDispatch()

  const { isCelebrity, token, userName, roomLink } = useSelector(state => state.participant);
  const { participants, copyModalOpened } = useSelector(state => state.session);
  const { remoteGroup, chatUserProfile } = useSelector(state => state.chat);

  const [isStreamCreated, setStreamCreateState] = useState(false)
  const [roomHasCelebrity, setRoomCelebrityPresence] = useState(false);
  const [roomsList, setRoomsList] = useState([])
  const [showedPopup, setShownPopup] = useState(false);

  const participantsRef = useRef(participants);
  const roomHasCelebrityRef = useRef(roomHasCelebrity);
  const isCelebrityRef = useRef(isCelebrity);
  const remoteGroupRef = useRef(remoteGroup)
  const intervalIdRef = useRef(0);
  // const [isMobile, setIsMobile] = useState(false);
  const [copied, setCopiedState] = useState(false)
  const [isChatOpen, setChatDialogState] = useState(false);
  const [localParticipant, setLocalParticipant ] = useState(null)
  const localParticipantRef = useRef(localParticipant);
  const copyDialogTimer = useRef(null);

  const isMobile = useIsMobilePlatform()


  useEffect(() => {
    isCelebrityRef.current = isCelebrity;
  }, [isCelebrity])

  useEffect(() => {
    localParticipantRef.current = localParticipant;
  }, [localParticipant])

  useEffect(() => {
    remoteGroupRef.current = remoteGroup
  }, [remoteGroup])
  useEffect(() => {
    participantsRef.current = participants;
    if(participants.length > 3){
      if(copyDialogTimer.current !== null){
        clearTimeout(copyDialogTimer.current)
      }
    }
  }, [participants]);

  useEffect(() => {
    if (isCelebrityRef.current) {
      setStreamCreateState(true)
      intervalIdRef.current = setInterval(() => getRoomsList(), 3000)
    }

    return () => {
      clearInterval(intervalIdRef.current)
    }
  }, [isCelebrityRef.current])

  useEffect(() => {
    initializeSyncSdk()
    processRoom()
  }, [roomId])

  useEffect(() => {
    if (isCelebrity !== null && userName) {
      if (isCelebrity) {
        if (roomHasCelebrity) {
          return
        }

        makeCelebrityLocal()

      } else {
        if (token && userName) {
          WT.Session.connect(token, userName, {}, { isCelebrity: isCelebrity })
        }
      }
    }
  }, [token, userName, isCelebrity]);



  useEffect(() => {
    roomHasCelebrityRef.current = roomHasCelebrity;
  }, [roomHasCelebrity]);

  useEffect(() => {

    WT.ErrorsListeners.onSessionError((error) => {
      if (error.code === 206) {
        dispatch(setSessionError('Unable to join the room. Exceeded limit of streaming participants'))

        dispatch(resetParticipantStore())
        stopLocalStream()
        dispatch(setParticipants([]))
      }
    })

    WT.ParticipantListeners.onParticipantJoin((params) => {
      if(remoteGroupRef && remoteGroupRef.current){
       setTimeout(() => {
         sendGroup(remoteGroupRef.current)
       }, 3000)
      }
    })

    // let participants = [];

    WT.SessionListeners.onConnected((params) => {
      if (!params.length) {
        dispatch(setJoinModalState(true))
      }

      WT.SessionListeners.onStreamCreated((params) => {
        console.log("on stream created ", params )
       WT.Participant.setMediaQuality({videoWidth:320, videoHeight:240, frameRate:12})
        const newPs = participantsRef.current.filter(p => p.participantId !== params.participantId)
        dispatch(setParticipants([...newPs, params ]))


        if(params.local)
          setLocalParticipant(params);

        setStreamCreateState(true);

        const alreadyExists = participantsRef.current.find(p => p.participantId === params.participantId);

        if (alreadyExists) {
          const video = document.getElementById('participant-' + params.participantId);
          video.src = params.stream;
        } else if (params.isCelebrity) {
          setRoomCelebrityPresence(params)
        } else {
          dispatch(setParticipants([...participantsRef.current]))
        }

        if(!showedPopup){
          if(participantsRef.current.length < 3 && params.local ===true){
            copyDialogTimer.current = setTimeout(() => {
              setShownPopup(true)
              dispatch(setJoinModalType('COPY_MODAL'))
            },7000)
          }
        }
      });
      WT.ReconnectListeners.onLocalParticipantReconnected((params) => {
        dispatch(setParticipants([]))
      })
      WT.ReconnectListeners.onLocalConnectionLost(() => {
        console.log('local is ', localParticipant, localParticipantRef.current)
      })

      WT.ParticipantListeners.onParticipantLeft(({ participantId }) => {
        if (roomHasCelebrityRef?.current && roomHasCelebrityRef?.current?.participantId === participantId) {
          setRoomCelebrityPresence(null)
        } else {
          // participants = [...participants.filter(p => p.participantId !== participantId)];
          dispatch(setParticipants(participantsRef.current.filter(p => p.participantId !== participantId)))
        }
      })
    })

    WT.SessionListeners.onDisconnected((params) => {
      //participants = []
    })

    return () => {
      if(copyDialogTimer.current !== null)
        clearTimeout(copyDialogTimer.current)
    }
  }, []);

  const makeCelebrityLocal = () => {
    dispatch(setParticipants([]))
    const constraints = {
      'video': true,
      'audio': false
    }
    navigator.mediaDevices.getUserMedia(constraints).then(device => (
        setRoomCelebrityPresence({ stream: device, participantId: '1' })
    ))
  }

  const stopLocalStream = () => {
    const tracks = roomHasCelebrityRef?.current?.stream?.getTracks()

    if (tracks && tracks.length > 0) {
      tracks[0].stop()
    }
  }

  useEffect(() => {
    return () => {
      stopLocalStream()
    }
  }, [])

  const processRoom = async () => {
    if (roomId && roomId !== 'c') {
      dispatch(setRoomProcessingModalState(true))

      try {
        const res = await vrtApiRequest.get(`/room/${roomId}`);

        dispatch(setJoinModalType('USER_DATA_ENTRY'))

        if (res.data.token) {
          dispatch(setGainedToken(res?.data))

          dispatch(setRoomProcessingModalState(false))
        } else {
          dispatch(setTimeBeforeMeeting(moment.duration(res?.data?.toStart, 'minutes').humanize()))
        }

      } catch (error) {
        if (error.message.includes('400')) {
          dispatch(setRoomCheckerError('Room does not exist. Please try to use another link.'))
          return
        }
        dispatch(setRoomCheckerError('Unexpected error'))
      }
    }
  }

  const getRoomsList = async () => {

    const res = await vrtApiRequest.get('/room/get-available-rooms-for-celebrity');

    setRoomsList(res?.data || [])
  }

  function leaveCall() {
    WT.Session.disconnect();

    stopLocalStream()


    dispatch(setJoinModalState(false))
    setRoomCelebrityPresence(null)
    dispatch(setParticipants([]))
    dispatch(resetParticipantStore())
    // dispatch(setSurveyModalState(true))

    dispatch(setJoinModalType('BUTTONS'))
    if(participants.length === 1){
        // deleteRoom(remoteGroup.id || null)
    }
    if(copyDialogTimer.current !==null){
      clearTimeout(copyDialogTimer.current)
    }
  }



  const inviteFriends = () => {
    dispatch(setJoinModalType('COPY_MODAL'))
    if(copyDialogTimer.current !== null){
      clearTimeout(copyDialogTimer.current);
    }
  };

  const toggleChat = () => {
    if(isChatOpen){
      setChatDialogState(false)
    }else {
      setChatDialogState(true)
    }
  }

  return (
      <div className='session-container'>
        <div className='session-mine-content'>

          <div className='s-participants-container left_marging'>
            {/*<div className='s-participants-empty-space' />*/}

            <ParticipantsList />
            <div className='add-user-button-container'>
              {!isCelebrity && participants.length < 4 && (
                  <div className='sfb-footer-buttons'>
                    <button
                        className={`add-sfb-button sfb-button ${copied ? 'active' : ''}`}
                        onClick={inviteFriends}
                    >
                      <div className='invite-user-button'>Link kopieren und Freunde einladen</div>
                    </button>
                  </div>
              )}
            </div>
          </div>

          {roomHasCelebrity && (
              <div className='s-participants-container right_margin'>
                <div className='s-participants-empty-space' />

                <div className='s-participant-video-block-wrapper'>
                  <div className='s-participant-video-block celebrity'>
                    <Video participant={roomHasCelebrity} />
                  </div>
                </div>

                {isCelebrity && (
                    <FooterButtons leaveCall={leaveCall} />
                )}
              </div>
          )}

          {(isStreamCreated || !isMobile) && (<div className='s-activity-container'>
            <div className='s-participants-empty-space' />

            <div className={`s-player-container ${!token ? 'placeholder' : ''} ${isCelebrity ? 'celebrity' : ''}`}>
              {isStreamCreated && (token || isCelebrity) ? (
                  <Player isCelebrity={isCelebrity} />
              ) : (
                  <div className='s-player-button-placeholder' />
              )}
            </div>


            <div className={`s-session-footer ${isCelebrity ? 'celebrity' : ''}`}>
              <CelebrityTable
                  visible={isCelebrity}
                  data={roomsList}
                  makeCelebrityLocal={makeCelebrityLocal}
              />

              {!isCelebrity && (
                  <FooterButtons leaveCall={leaveCall} openChatWindow={() => {toggleChat()}} />
              )}
            </div>
          </div>)}

        </div>
        {!isMobile ? <div className='chart-content'>
          {isStreamCreated && (token || isCelebrity) &&
          <ChatTabs closeChatWindow={() => setChatDialogState(false)} />
          }
          {!token && <div className={'chat-placeholder'}>
            <div className='placeholder-header'> </div>
            <div className='placeholder-chat-message'></div>
            <div className='placeholder-chat-own-message'></div>
            <div className='placeholder-chat-message'></div>
            <div className='placeholder-chat-message'></div>
            <div className='placeholder-chat-own-message'></div>
            <div className='placeholder-footer'></div>
          </div>}
        </div> : <div className={`chart-content-mobile ${isChatOpen? '':'chat-inactive'}`}>
          {isStreamCreated && (token || isCelebrity) &&
          <ChatTabs closeChatWindow={() => setChatDialogState(false)} />
          }
          {!token && <div className={'chat-placeholder'}>
            <div className='placeholder-header'> </div>
            <div className='placeholder-chat-message'></div>
            <div className='placeholder-chat-own-message'></div>
            <div className='placeholder-chat-message'></div>
            <div className='placeholder-chat-message'></div>
            <div className='placeholder-chat-own-message'></div>
            <div className='placeholder-footer'> </div>
          </div>}
        </div> }


        <JoinModal  />

        <RoomCheckerModal />

        {/*<CelebrityPopup />*/}

        <SessionError />

        <SurveyModal />
      </div >
  )
}

export default Session;
